import React from 'react';
import PropTypes from 'prop-types';
import { Tabs, Tab, styled } from '@mui/material';

const TabsWrapper = styled(Tabs)(({ theme }) => ({
  border: `4px solid ${theme.palette.primary.main}`,
  padding: theme.spacing(0.25),
  borderRadius: 9999,
  zIndex: 0, // In whatif there's a spot where this is necessary or else you can't see anything due to some other zIndex madness
  '& .FD-MuiTabs-indicator': {
    height: '100%',
    borderRadius: 9999,
    zIndex: -1,
  },
  '& .FD-MuiButtonBase-root': {
    padding: theme.spacing(1.5),
    fontWeight: 400,
    color: theme.palette.primary.main,
  },
  '& .FD-MuiButtonBase-root.Mui-selected': {
    fontWeight: 400,
    color: theme.palette.background.paper,
  },
}));

export const CustomizationToggle = ({
  options, value, onChange,
}) => {
  return (
    <TabsWrapper
      value={value}
      onChange={(evt, newValue) => {
        onChange(newValue);
      }}
    >
      {options.map(({ name, value: optionValue }) => {
        return (
          <Tab label={name} value={optionValue} />
        );
      })}
    </TabsWrapper>
  );
};

CustomizationToggle.propTypes = {
  options: PropTypes.array.isRequired,
  value: PropTypes.array.isRequired,
  onChange: PropTypes.array.isRequired,
};
